module.exports = __webpack_public_path__ + "media/images/tutors/PrepWorks-Lakshan-6d0c7be6f9dcd7299453c704a33c52d5.jpg";